(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/error-code-handler/assets/javascripts/error-code-handler.js') >= 0) return;  svs.modules.push('/components/marketplace-data/error-code-handler/assets/javascripts/error-code-handler.js'); 'use strict';

var _svs$components$marke = svs.components.marketplaceData.errorCodeHandler,
    warnings = _svs$components$marke.constants.warnings,
    _svs$components$marke2 = _svs$components$marke.helpers,
    getDrawAmountLimit = _svs$components$marke2.getDrawAmountLimit,
    checkPlayerExclusions = _svs$components$marke2.checkPlayerExclusions;
var format = svs.utils.format;
var codes = {
  2: {
    readMessage: 'Något gick fel, försök igen senare.',
    specificGameMessage: function specificGameMessage() {
      return 'Något gick fel, försök igen senare.';
    },
    warning: warnings.AMOUNT_BELOW_LIMIT
  },
  3: {
    readMessage: 'Laget har avslutats eller är påväg att avslutas',
    specificJoinTeamMessage: function specificJoinTeamMessage() {
      return 'Du kan inte gå med i det här laget eftersom att det har avslutats';
    },
    warning: warnings.GROUP_NOT_ACTIVE
  },
  5: {
    readMessage: 'Kunde inte hitta inbjudan. Kontrollera länken eller be lagkaptenen om en ny.',
    warning: warnings.TOKEN_MISSING
  },
  7: {
    readMessage: 'Inbjudningslänken är inte längre giltig. Du kan be lagkaptenen skapa en ny.',
    warning: warnings.INVITATION_EXPIRED
  },
  9: {
    readMessage: 'Du kan inte gå med i laget eftersom att det är fullt.',
    specificTeamNameMessage: function specificTeamNameMessage(name) {
      return "Du kan inte g\xE5 med i ".concat(name, " eftersom laget \xE4r fullt.");
    },
    warning: warnings.TEAM_FULL
  },
  11: {
    readMessage: 'Du är redan medlem i laget',
    specificTeamNameMessage: function specificTeamNameMessage(name) {
      return "Du \xE4r redan medlem i ".concat(name, ".");
    },
    warning: warnings.ALREADY_MEMBER
  },
  12: {
    readMessage: 'Något gick fel i medlemshanteringen.',
    warning: warnings.MEMBER_NOT_FOUND
  },
  13: {
    readMessage: 'Lagnamnet är upptaget.',
    specificTeamNameMessage: function specificTeamNameMessage(name) {
      return "Lagnamet \"".concat(name, "\" \xE4r upptaget.");
    },
    warning: warnings.GROUP_NAME_ALREADY_EXISTS
  },
  15: {
    checkPlayerExclusions: true,
    warning: warnings.CUSTOMER_NOT_ACTIVE
  },
  18: {
    readMessage: 'Du har nått max antal lag.',
    specificFollowLimitMessage: function specificFollowLimitMessage(name, apiMessage) {
      var limitText = "redan \xE4r med i ".concat(getLimitFromApiMessage(apiMessage), " lag");
      return "Du kan inte g\xE5 med i ".concat(name, ", eftersom att du ").concat(limitText, ".");
    },
    specificFractionPaymentMessage: function specificFractionPaymentMessage(apiMessage) {
      return "Det gick inte att k\xF6pa en andel, eftersom du f\xF6ljer max antal lag (".concat(getLimitFromApiMessage(apiMessage), ").");
    },
    warning: warnings.MAX_GROUPS_REACHED
  },
  19: {
    readMessage: 'Det gick inte att köpa en andel just nu, försök igen senare.',
    warning: warnings.MEMBER_ACTIVE
  },
  20: {
    readMessage: 'Det går inte att utföra denna åtgärd eftersom det finns aktiva spel.',
    specificGameMessage: function specificGameMessage() {
      return 'Det gick inte att köpa en andel just nu på grund av ett tekniskt fel, försök igen.';
    },
    specificTeamMessage: function specificTeamMessage() {
      return 'Det gick inte att avsluta laget eftersom det finns aktiva spel.';
    },
    warning: warnings.GROUP_ACTIVE
  },
  21: {
    readMessage: 'Det gick inte att köpa någon andel på grund av ett tekniskt fel.',
    warning: warnings.CREATOR_BUYIN_FAILED
  },
  22: {
    readMessage: 'Du överskrider max-gränsen på denna omgång.',
    specificProductIdMessage: function specificProductIdMessage(productId) {
      return "Du \xF6verskrider maxgr\xE4nsen ".concat(format.Currency(getDrawAmountLimit(productId)), " kr p\xE5 denna omg\xE5ng.");
    },
    warning: warnings.ITS_MAX_AMOUNT_EXCEEDED
  },
  23: {
    readMessage: 'Det går inte att köpa fler andelar i spelet.',
    warning: warnings.NO_SHARES_AVAILABLE
  },
  24: {
    readMessage: 'Du har för lite pengar på ditt spelkonto.',
    warning: warnings.OPS_INSUFFICIENT_FUNDS
  },
  26: {
    readMessage: 'Vår server svarar inte på grund av ett tekniskt fel.',
    warning: warnings.OPS_ACCOUNT_NOT_REACHABLE
  },
  28: {
    readMessage: 'Din kontostatus tillåter inte köp. Kontakta gärna kundservice om du vill veta mer.',
    warning: warnings.CUSTOMER_INACTIVE_ACTIVE_IN_GROUP
  },
  35: {
    readMessage: 'Du behöver vara speladmin eller lagkapten för att utföra denna åtgärd.',
    warning: warnings.USER_NOT_OWNER_OR_ADMIN
  },
  36: {
    readMessage: 'Vi kunde inte hitta spelet.',
    warning: warnings.CONTAINER_NOT_FOUND
  },
  37: {
    readMessage: 'Vi kunde inte hitta spelet.',
    warning: warnings.ACTIVATED_DRAW_NOT_FOUND
  },
  39: {
    readMessage: 'För få andelar sålda på spelet.',
    warning: warnings.TOO_FEW_SHARES_SOLD
  },
  41: {
    readMessage: 'Spelet verkar redan vara inlämnat.',
    warning: warnings.ACTIVATED_DRAW_CLOSED
  },
  43: {
    readMessage: 'Vår server svarar inte på grund av ett tekniskt fel.',
    warning: warnings.NO_OPS_REPLY
  },
  44: {
    readMessage: 'Vår server svarar inte på grund av ett tekniskt fel.',
    warning: warnings.NO_ITS_REPLY
  },
  47: {
    readMessage: 'Du har redan maximalt antal andelar.',
    warning: warnings.MAX_SHARES_PER_MEMBER_REACHED
  },
  49: {
    readMessage: 'Något gick fel - kolla så att du har angett rätt information.',
    specificGameMessage: function specificGameMessage() {
      return 'Andelsköpstiden du har valt har passerat.';
    },
    warning: warnings.BUYIN_CLOSE_BEFORE_CURRENT
  },
  50: {
    readMessage: 'Servern är upptagen, försök igen senare.',
    warning: warnings.MINERVA_BUSY
  },
  55: {
    readMessage: 'Laget överskrider max-gränsen på denna omgång.',
    specificProductIdMessage: function specificProductIdMessage(productId) {
      return "Laget f\xE5r inte spela f\xF6r mer \xE4n ".concat(svs.utils.format.Currency(getDrawAmountLimit(productId)), " kr p\xE5 samma spelomg\xE5ng.");
    },
    warning: warnings.WAGER_MAX_GROUP_AMOUNT_EXCEEDED
  },
  56: {
    readMessage: 'Det finns redan ett spel skapat på den här omgången.',
    warning: warnings.BAD_DRAWNUM
  },
  58: {
    readMessage: 'Produkten är tillfälligt stängd, försök igen senare.',
    warning: warnings.REGBET_DISABLED
  },
  72: {
    readMessage: 'Laget överskrider max-gränsen på denna omgång.',
    specificProductIdMessage: function specificProductIdMessage(productId) {
      return "Laget f\xE5r inte spela f\xF6r mer \xE4n ".concat(svs.utils.format.Currency(getDrawAmountLimit(productId)), " kr p\xE5 samma spelomg\xE5ng.");
    },
    warning: warnings.WAGER_MAX_GROUP_AMOUNT_EXCEEDED
  },
  401: {
    readMessage: 'Du saknar behörighet för denna åtgärd.'
  },
  404: {
    readMessage: 'Vi kunde inte hitta det du söker.',
    warning: warnings.RESOURCE_NOT_FOUND
  }
};

var getLimitFromApiMessage = function getLimitFromApiMessage(apiMessage) {
  var unescapedMsg = unescape(apiMessage);
  var value = unescapedMsg.substring(unescapedMsg.indexOf('(') + 1, unescapedMsg.indexOf(')'));
  return parseInt(value, 10) || 'max antal';
};

var getReadMessage = function getReadMessage() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return error.readMessage || options.defaultMessage || 'Något gick fel, var god försök igen senare.';
};

var getMessageByOptions = function getMessageByOptions() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (options.overrideErrorMessage && options.overrideErrorMessage[error.warning]) {
    return options.overrideErrorMessage[error.warning];
  }

  if (options.productId && error.specificProductIdMessage) {
    return error.specificProductIdMessage(options.productId);
  }

  if (options.specificGameMessage && error.specificGameMessage) {
    return error.specificGameMessage();
  }

  if (options.specificTeamMessage && error.specificTeamMessage) {
    return error.specificTeamMessage();
  }

  if (options.specificFollowLimitMessage && error.specificFollowLimitMessage) {
    return error.specificFollowLimitMessage(options.name, options.apiMessage);
  }

  if (options.specificFractionPaymentMessage && error.specificFractionPaymentMessage) {
    return error.specificFractionPaymentMessage(options.apiMessage);
  }

  if (options.name && error.specificTeamNameMessage) {
    return error.specificTeamNameMessage(options.name);
  }

  if (options.joinTeamMessage && error.specificJoinTeamMessage) {
    return error.specificJoinTeamMessage();
  }

  return '';
};

var getErrorMessage = function getErrorMessage(errorCode, callback, options) {
  var error = codes[errorCode] || {};
  var errorMessage = getReadMessage(error, options); 

  if (error.checkPlayerExclusions || getWarning(errorCode) === warnings.NOT_DEFINED) {
    if (options && options.shouldCheckPlayerExclusions) {
      checkPlayerExclusions(function (message) {
        return callback({
          message: message || errorMessage,
          isHTML: Boolean(message) 

        });
      });
    } else {
      callback({
        message: errorMessage
      });
    }
  } else {
    if (options) {
      errorMessage = getMessageByOptions(error, options) || errorMessage;
    }

    callback({
      message: errorMessage,
      isHTML: false
    });
  }
};

var getWarning = function getWarning(errorCode) {
  return codes[errorCode] ? codes[errorCode].warning : warnings.NOT_DEFINED;
};

setGlobal('svs.components.marketplaceData.errorCodeHandler.getErrorMessage', getErrorMessage);
setGlobal('svs.components.marketplaceData.errorCodeHandler.getWarning', getWarning);
 })(window);